import { Image } from "./image";
import React from "react";
import { Helmet } from "react-helmet";

export const Gallery = (props) => {
  return (
    <div id="portfolio" className="text-center">
      {props.isStandalone && <Helmet htmlAttributes={{ lang: "en" }}>
        <title>Gallery - ICL Software Events & Highlights</title>
        <link rel="canonical" href="https://eximon.com/gallery/" />
        <meta charSet="utf-8" />
        <meta name="description" content="Browse our gallery of events, product showcases, and client highlights to see ICL Software solutions in action." />

        {/* Open Graph */}
        <meta property="og:title" content="Gallery - ICL Software Events & Highlights" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://eximon.com/gallery/" />
        <meta property="og:description" content="Explore our gallery of events, product showcases, and client highlights to see ICL Software solutions in action." />
        <meta property="og:image" content="https://eximon.com/img/apple-touch-icon.png" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Gallery - ICL Software Events & Highlights" />
        <meta name="twitter:description" content="Browse our gallery of events, product showcases, and client highlights to see ICL Software solutions in action." />
        <meta name="twitter:image" content="https://eximon.com/img/apple-touch-icon.png" />
        <script type="application/ld+json">
          {`
{
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "SoftwareApplication",
      "@id": "https://eximon.com/gallery",
      "url": "https://eximon.com/gallery",
      "name": "ICL Gallery - Events & Highlights",
      "applicationCategory": "BusinessApplication",
      "operatingSystem": "Web",
      "description": "Browse our gallery of events, product showcases, and client highlights to see ICL Software solutions in action.",
      "keywords": "Team, Experts, Enterprise Software, Innovation",
      "inLanguage": "en",
      "isPartOf": {
        "@id": "https://eximon.com/"
      }
    },
    {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://eximon.com/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Team",
          "item": "https://eximon.com/team"
        }
      ]
    }
  ]
}
`}
        </script>
      </Helmet>}
      <div className="container">
        <div className="section-title">
          <h1>Gallery</h1>
          <h2>Explore our gallery to see our work, products, and services in action.</h2>
        </div>
        <div className="row">
          <div className="portfolio-items">
            {props.data
              ? props.data.map((d, i) => (
                <div
                  key={`${d.title}-${i}`}
                  className="col-sm-6 col-md-4 col-lg-4"
                >
                  <Image
                    title={d.title}
                    largeImage={d.largeImage}
                    smallImage={d.smallImage}
                  />
                </div>
              ))
              : "Loading..."}
          </div>
        </div>
      </div>
    </div>
  );
};
